import { mapMutations } from 'vuex'
import { util } from 'pevueglobal'

const Globalmixins = {
  data: function() {
    return {
      dateformat: PEGLOBALS.Xdateformat.toUpperCase(), // dit dateformat uppercase word alleen gebruikt voor vee-lidate, helaas gebruiken die weer een ander formaat als date-fns
      ValidationGritterID: null
    }
  },
  methods: {
    ...mapMutations(['startLoading', 'stopLoading', 'setvalidationMessageStatus']),
    getDownloadUrl: function(id, filehash) {
      return util.createApiUrl(`/public/PEfile/${id}/${filehash}`)
    },
    DateOrEmpty(Idate) {
      if ((Idate instanceof Date && !isNaN(Idate)) === false) {
        return new Date('1900-01-01')
      } else {
        return Idate
      }
    },
    XVvalidate() {
      // controleer of dat er een validator op het component zit waar deze functie word afgetrapt
      if (this.$validator) {
        // open XVvalidationMessage (validatie overzicht notificatie)
        this.setvalidationMessageStatus(true)
        // voer de validatie uit en return de promise naar component (promise met true/false na async validatie)
        return this.$validator.validate()
      } else {
        throw new Error(
          "$validate niet aanwezig, inject deze als het een child component is met inject: ['$validator']"
        )
      }
    }
  }
}

export default Globalmixins
